<template>
  <div class="status status_padding animated animatedFadeInUp fadeInUp">
    <div class="status__column">
      <div class="title title_position">Статусы</div>
      <vc-donut
        background="white" foreground="grey"
        :size="189" unit="px" :thickness="11"
        :sections="sections" :total="100"
      >
        <p class="status__sup" ref="moneySum"></p>
        <p class="status__sub" ref="deviceCount"></p>
      </vc-donut>
    </div>
    <div class="table table_margin">
      <template v-for="(item) in status">
        <template v-for="(bucket, index) in item">
          <div class="table__item" v-if="bucket.key === 10" :key="bucket.key + index + 2">
            <div class="table__item-name dot dot_purple">Оплачено</div>
            <div class="table__item-wrapper">
              <div ref="pay" class="table__item-count">{{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value) || 0}} ₸</div>
            </div>
          </div>
          <div class="table__item" v-if="bucket.key === 9" :key="bucket.key + index  + 2">
            <div class="table__item-name dot dot_green">Ждет оплату</div>
            <div  class="table__item-wrapper">
              <div ref="waitPay" class="table__item-count"> {{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value) || 0}} ₸</div>
            </div>
          </div>
          <div class="table__item" v-if="bucket.key === 11" :key="bucket.key + index  + 2">
            <div class="table__item-name dot dot_red">На претензии</div>
            <div  class="table__item-wrapper">
              <div ref="toClaims" class="table__item-count">{{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value) || 0}} ₸</div>
            </div>
          </div>
          <div class="table__item" v-if="bucket.key === 6" :key="bucket.key + index  + 2">
            <div class="table__item-name dot dot_blue">В пути</div>
            <div  class="table__item-wrapper">
              <div ref="inWay" class="table__item-count"> {{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value) || 0}} ₸</div>
            </div>
          </div>
          <div class="table__item" v-if="bucket.key === 4" :key="bucket.key + index  + 2">
            <div class="table__item-name dot dot_orange">В магазинах</div>
            <div class="table__item-wrapper">
              <div ref="inShop" class="table__item-count"> {{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value) || 0}} ₸</div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex';

  export default {
    name: 'RoundChart',
    data: () => ({
      paidDonut: null,
      sections: [
        { label: 'Оплачено', value: 0, color: '#4C1E87' },
        { label: 'В пути', value: 0, color: '#46BCFE' },
        { label: 'Ждет оплату', value: 0, color: '#89CC0E' },
        { label: 'На претензии', value: 0, color: '#EB2F72' },
        { label: 'В магазинах', value: 0, color: '#FFBE5D' },
      ],
      status: null,
      isMoneySum: false,
    }),
    watch: {
      changeDonuts() {
        this.$nextTick(() => this.addValueDonut(), 1000);
      },
      elasticInfo(data) {
        if(data.aggregations.MoneySum.value !== undefined) {
          this.$refs.moneySum.innerText = this.moneySum + ' ₸';
          this.isMoneySum = true;
        }

        if(data.aggregations.DeviceCount.value !== undefined) {
          this.$refs.deviceCount.innerText = this.deviceCount + ' шт.'
        }

        if(data.aggregations.Status.buckets.length) {
          this.status = data.aggregations.Status;
        }
      }
    },
    computed: {
      ...mapState(['elasticInfo', 'changeDonuts']),
      moneySum() {
        let moneySum;
        if(this.elasticInfo.aggregations.MoneySum.value > 0) {
          moneySum = this.elasticInfo.aggregations.MoneySum.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else {
          moneySum = 0;
        }
        return moneySum;
      },
      deviceCount() {
        let moneySum;
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          moneySum = this.elasticInfo.aggregations.DeviceCount.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else {
          moneySum = 0;
        }
        return moneySum;
      },
      setPaidDonut() {
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          let donutPersent = 0;

          this.elasticInfo.aggregations.Status.buckets.map(element => {
            if(element.key === 10) {
              donutPersent = element.sum.value / this.elasticInfo.aggregations.MoneySum.value * 100;
            }
          });
          return donutPersent;
        } else {
          return  0;
        }
      },
      setInWayDonut() {
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          let donutPersentOne = 0;


          this.elasticInfo.aggregations.Status.buckets.map(element => {
            if(element.key === 6) {
              donutPersentOne = element.sum.value / this.elasticInfo.aggregations.MoneySum.value * 100;
            }


          });
          return donutPersentOne
        } else {
          return  0;
        }
      },
      setWaitPayDonut() {
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          let donutPersent = 0;

          this.elasticInfo.aggregations.Status.buckets.map(element => {
            if(element.key === 9) {
              donutPersent = element.sum.value / this.elasticInfo.aggregations.MoneySum.value * 100;
            }
          });
          return donutPersent;
        } else {
          return  0;
        }
      },
      setToClaimsDonut() {
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          let donutPersent = 0;

          this.elasticInfo.aggregations.Status.buckets.map(element => {
            if(element.key === 11) {
              donutPersent = element.sum.value / this.elasticInfo.aggregations.MoneySum.value * 100;
            }
          });
          return donutPersent;
        } else {
          return  0;
        }
      },
      setInShopDonut() {
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          let donutPersent;

          this.elasticInfo.aggregations.Status.buckets.map(element => {
            if(element.key === 4) {
              donutPersent = element.sum.value / this.elasticInfo.aggregations.MoneySum.value * 100;
            }
          });
          return donutPersent;
        } else {
          return  0;
        }
      }

    },
    methods: {
      ...mapActions(['SET_FILTER_VALUE', 'GET_INFO_FILTER']),

      formatPrice(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },
      addValueDonut() {
        this.sections.map((section) => {
          if(section.label === 'Оплачено') {
            section.value = this.setPaidDonut;
          }

          if(section.label === 'В пути') {
            section.value = this.setInWayDonut;
          }

          if(section.label === 'Ждет оплату') {
            section.value = this.setWaitPayDonut;
          }

          if(section.label === 'На претензии') {
            section.value = this.setToClaimsDonut;
          }

          if(section.label === 'В магазинах') {
            section.value = this.setInShopDonut;
          }
        });
      },
    },

    mounted() {
      this.SET_FILTER_VALUE()
        .then(() => this.addValueDonut())
      // this.resultDonuts();
    }

  };
</script>
